import { render, staticRenderFns } from "./AuthorizeAction.vue?vue&type=template&id=a8467ea8&scoped=true&"
var script = {}
import style0 from "./AuthorizeAction.vue?vue&type=style&index=0&id=a8467ea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8467ea8",
  null
  
)

export default component.exports